import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from "./index.less";

export default function Layout(props) {
  useEffect(() => {
    console.log('====== Layout Mounted on Client ======');
  }, []);

  const {
      seoMetas = {},
      cjHeaderConfig = {},
      cjFooterConfig = {},
      state,
      children,
      style,
      helper,
      vipClass,
      mfComponents,
      siteCheck,
      menuCollapsedWidth,
      themeVariables,
      PUBLIC,
      PUBLIC_LIBS,
      PUBLIC_IMG,
      PUBLIC_SCRIPT,
      PUBLIC_STYLE,
      CDN_VERSION_PATH,
      CDN_HOST,
      EGG_ENV,
      EGG_ENV_DEV,
      NODE_ENV,
      OSS_HOST,
      pageAssets = { js: [], css: [] },
      layoutAssets = { js: [], css: [] },
      windowDataScript = '',
      globalWindow,
      debuggerInfo,
      langExternalSrc = '', // 词库外置:common 外链地址(空=未启用,走内联整包)
      langInlineJs = '',    // 词库外置:当页 page bucket 内联 JS
      containerClassName = '', // 单页布局样式控制:附加到 .cj-container 的 className(默认空=不影响其它页)
    } = props;

    return (
      <html lang="en">
        <head>
          <meta charSet="utf-8" />
          {/**
           * @注意 viewport meta 是移动端响应式布局的必要条件。
           * 缺少此标签时，移动浏览器会按默认宽度（约980px）渲染页面，
           * 导致所有基于 max-width 的 media query 不会在预期断点触发。
           */}
          <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
          <title>{seoMetas.title}</title>
          <meta name="googlebot" content="NOODP" />
          <link rel="canonical" href={seoMetas.canonical} />
          {/* 浏览器tab的favicon */}
          <link rel="shortcut icon" href={siteCheck.data('favicon')} />
          {/* <!-- seo信息 --> */}
          <meta name="description" content={seoMetas.description} />
          <meta name="keywords" content={seoMetas.keywords} />

          {/* <!-- Facebook --> */}
          <meta property="og:type" content={seoMetas.facebook.type} />
          <meta property="og:title" content={seoMetas.title} />
          <meta property="og:description" content={seoMetas.description} />
          <meta property="og:image" content={seoMetas.image.url} />
          <meta property="og:image:width" content={seoMetas.image.width} />
          <meta property="og:image:height" content={seoMetas.image.height} />
          <meta property="og:url" content={seoMetas.link} />
          <meta property="fb:app_id" content={seoMetas.facebook.app_id} />

          {/* <!-- Twitter --> */}
          <meta name="twitter:card" content={seoMetas.twitter.card} />
          <meta name="twitter:type" content={seoMetas.twitter.type} />
          <meta name="twitter:domain" content={seoMetas.domain} />
          <meta name="twitter:image" content={seoMetas.image.url} />
          <meta name="twitter:title" content={seoMetas.title} />
          <meta name="twitter:description" content={seoMetas.description} />
          <meta name="twitter:url" content={seoMetas.link} />

          {/* 申请做Impact平台的分销客，需要证明网站为Impact用户CJ Park为同一家公司 */}
          <meta name='ir-site-verification-token' value='1292601014' />
          {/* 词库外置:先外链 common(全站缓存复用),再在下面的内联脚本里 assign 当页 page bucket */}
          {langExternalSrc ? <script src={langExternalSrc}></script> : null}
          <script dangerouslySetInnerHTML={{
            __html: `
            ${langInlineJs}
            // 将一些模板变量抛给 js
            const PUBLIC = '${PUBLIC}';
            const PUBLIC_LIBS = '${PUBLIC_LIBS}';
            const PUBLIC_IMG = '${PUBLIC_IMG}';
            const PUBLIC_SCRIPT = '${PUBLIC_SCRIPT}';
            const PUBLIC_STYLE = '${PUBLIC_STYLE}';
            const CDN_VERSION_PATH = '${CDN_VERSION_PATH}';
            const CDN_HOST = '${CDN_HOST}'

            // egg 环境变量
            const EGG_ENV = '${EGG_ENV}';
            const EGG_ENV_DEV = '${EGG_ENV_DEV}';

            // 需求来源：26年06月24日「React SSR 页登录注册按钮样式丢失」修复（GHDR-CR-EGG-SSR）。
            // 头部去用户化的客户端渲染标志：njk 页经 cjHeaderConfig.script 注入，本 React SSR Layout 不注入 script，
            // 故须在 mf CjHeader 水合前（本内联脚本早于 head 内 mf 头部 <script src>）置位同一标志，
            // 使客户端首帧与 SSR 登录态占位一致、消除 hydration 不匹配（否则按钮被并入占位 div、丢 .notSafeLoginBox 包裹类→样式全失）。
            // 取 commonTopSsr 下发的裸赋值语句（停用时为空串、不污染 window）。详见 productCdnHeader.buildHeaderClientRenderInlineStatement。
            ${cjHeaderConfig.headerClientRenderInline || ''}

            // 其他变量
            ${Object.keys(cjHeaderConfig.vars || {}).map(key => `window.${key} = \`${JSON.stringify(cjHeaderConfig.vars[key])}\`;`).join('\n')}
            ${Object.keys(cjFooterConfig.vars || {}).map(key => `window.${key} = \`${JSON.stringify(cjFooterConfig.vars[key])}\`;`).join('\n')}
            ${globalWindow}
            ${debuggerInfo(true)}
            `
          }}></script>
          {/* 需求来源：docs/旅游落地页/AI提示词.md 第1次提交第1次补充（DEV-120352）—— iconfont 项目 1265799 升版
              s3zubbmw2t → fdkj2fnqx4b，新增 iconjihua(e8f1)/iconlvhang(e8f2)/iconhangchengdan(e8f4)/iconchima(e8f0)，
              供 /cj-business-travel 的「Plan Your China Trip in Three Steps」三步骤图标使用。
              本行是全站 React-SSR 页的 iconfont 源头，升版前已逐类名比对两版 CSS：旧版 801 个图标在新版中
              **一个不缺、码位无变化**，新版为严格超集（805 个），故全站替换无回归风险。 */}
          <link rel="stylesheet" href="//at.alicdn.com/t/c/font_1265799_fdkj2fnqx4b.css" />
          <link rel="stylesheet" href={`${OSS_HOST + '/.sprite/flag.css'}`} />
          {/* Bootstrap 4 全局样式 - NJK模板通过 head.njk 引入，SSR Layout 需单独引入以保持一致 */}
          <link rel="stylesheet" href={`${PUBLIC_LIBS}/bootstrap-4.4.1/bootstrap.min.css`} />
          <link rel="stylesheet" href={`${CDN_VERSION_PATH}/static/css/reset.css`} />
          {layoutAssets.css.map((css, index) => (
            <link key={`layout-css-${index}`} rel="stylesheet" href={css} />
          ))}
          {pageAssets.css.map((css, index) => (
            <link key={`page-css-${index}`} rel="stylesheet" href={css} />
          ))}
          {helper && <link rel="stylesheet" href={helper.getAssetUrl(helper.getPageName() + '.css')} />}

          <script src={`${PUBLIC_LIBS}/i18next-19.4.5/i18next.js`}></script>
          <script src={`${PUBLIC_LIBS}/jquery-3.4.1/jquery.js`}></script>
          <script src={`${PUBLIC_LIBS}/vue-2.6.11/vue.js`}></script>
          {/* react公用js  */}
          <script crossOrigin="crossorigin" src={`${CDN_HOST}/common-public/${NODE_ENV == 'development' ? 'react.development.js' : 'react.production.min.js'}`} onError="javascript:location.reload();"></script>
          <script crossOrigin="crossorigin" src={`${CDN_HOST}/common-public/${NODE_ENV == 'development' ? 'react-dom.development.js' : 'react-dom.production.min.js'}`} onError="javascript:location.reload();"></script>

          <script src={`${CDN_HOST}/common-public/axios.min.js`}></script>
          {/* <!-- lottie --> */}
          <script src={`${PUBLIC_LIBS}/lottie/lottie.js`}></script>
          {/* 注入页面自身的 SSR 样式 */}
          {style && <style dangerouslySetInnerHTML={{ __html: style }} />}
          {/* 注入远程组件的 CSS */}
          <link rel="stylesheet" href={mfComponents?.Menu?.css} />
          <link rel="stylesheet" href={mfComponents?.CjHeader?.css} />
          <link rel="stylesheet" href={mfComponents?.CjFooter?.css} />
          <link rel="stylesheet" href={mfComponents?.ProductCard?.css} />
          <link rel="stylesheet" href={mfComponents?.ServiceContentModal?.css} />
          {/* 注入远程组件的 Script */}
          <script src={mfComponents?.Menu?.js}></script>
          <script src={mfComponents?.CjHeader?.js}></script>
          <script src={mfComponents?.CjFooter?.js}></script>
          <script src={mfComponents?.ProductCard?.js}></script>
          <script src={mfComponents?.ServiceContentModal?.js}></script>
          {/* egg渲染的njk页面需要的js总入口 */}
          <script defer="defer" src={`${PUBLIC_SCRIPT}/cj-router.js`}></script>
          {/* PWA service-worker离线缓存，qk中有用到window.siteCheck，所以需要放cj-router下面 */}
          {siteCheck.isSite("CJ") && <link rel="manifest" href="/manifest.json"/>}
          <script src={`${CDN_HOST}/common-public/fingerprintjs.v4.min.js`}></script>
          <script src="/serverWork.js" defer="defer"></script>
          {/* <!-- google oneOne Tap sign-in --> */}
          <script dangerouslySetInnerHTML={{
            __html: `
              window.addEventListener('load', function () {
                  const element = document.createElement('script');
                  element.src = 'https://accounts.google.com/gsi/client';
                  document
                      .body
                      .appendChild(element)
              })
            `
          }}></script>
          {/* <!-- google oneOne Tap sign-in --> */}
          <style dangerouslySetInnerHTML={{
            __html: `
            :root {
              ${themeVariables};
            }
          `}} />
        </head>
        <body className={`${vipClass}`}>
          <div className={styles['cj-main']}>
            <div id="cj-menu" style={{ width: menuCollapsedWidth }}></div>
            <div className={`${styles['cj-container']}${containerClassName ? ' ' + containerClassName : ''}`}>
              {/* 注入远程 Header HTML */}
              <div id="cj-header-container" dangerouslySetInnerHTML={{ __html: cjHeaderConfig.html || '' }} />

              <div id="react-content">
                {children}
              </div>

              {/* 注入远程 Footer HTML */}
              <div id="cj-footer-container" dangerouslySetInnerHTML={{ __html: cjFooterConfig.html || '' }} />
              {/* AI助手 */}
              <div id="cj-ai-assistant-affix"></div>
            </div>
          </div>

          {/* 注入数据到 window 对象 */}
          <script dangerouslySetInnerHTML={{ __html: `window.__INITIAL_STATE__ = ${JSON.stringify(state || {})};` }} />
          {windowDataScript && <script dangerouslySetInnerHTML={{ __html: windowDataScript }} />}

          {/* 加载 Layout 的 JS */}
          {layoutAssets.js.map((js, index) => (
            <script key={`layout-js-${index}`} src={js}></script>
          ))}
          
          {/* 加载页面的 JS */}
          {pageAssets.js.map((js, index) => (
            <script key={`page-js-${index}`} src={js}></script>
          ))}

          {/* 兼容旧的 helper 方式 */}
          {helper && (
            <>
              <script src={helper.getAssetUrl(helper.getPageName() + '.js')}></script>
            </>
          )}
        </body>
      </html >
    );
}
